"use client"

import Script from "next/script"
import { useCookieConsent } from "./consent-context"
import LeadForensics from "./lead-forensics"

// Google tag IDs — GA4 is treated as Analytics, Google Ads as Marketing.
// The gtag.js loader itself is shared between the two; we only mount it
// if at least one of the two categories has been consented to.
export const GA4_MEASUREMENT_ID = "G-0ZDXTF7BH8"
const GOOGLE_ADS_IDS = ["AW-876271302", "AW-658434575"]

// Conditionally render trackers based on the visitor's consent.
//
//   marketing →  Mediahawk dynamic numbers, Lead Forensics, HubSpot live
//                chat, Google Ads config.
//   analytics →  Google Analytics 4 config.
//   either   →   gtag.js loader (shared between GA4 and Google Ads).
//
// Strict GDPR position: nothing in this component renders until the
// visitor has explicitly opted in to the matching category.
export default function TrackingScripts() {
  const { consent } = useCookieConsent()
  const analytics = consent?.analytics === true
  const marketing = consent?.marketing === true
  const needsGtag = analytics || marketing

  return (
    <>
      {marketing && (
        <>
          <Script id="mediahawk-mhct" strategy="afterInteractive">
            {`
              var _mhct = _mhct || [];
              _mhct.push(['mhCampaignID','VA-14262']);
              !function(){var c=document.createElement('script');
                  c.type='text/javascript',c.async=!0,c.src='//www.dynamicnumbers.mediahawk.co.uk/mhct.min.js';
                  var i=document.getElementsByTagName('script')[0];i.parentNode.insertBefore(c,i)}();
            `}
          </Script>
          <LeadForensics />
          <Script
            id="hs-script-loader"
            src="https://js-eu1.hs-scripts.com/145398209.js"
            strategy="afterInteractive"
          />
        </>
      )}

      {needsGtag && (
        <>
          <Script
            id="gtag-js"
            src={`https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`}
            strategy="afterInteractive"
          />
          <Script id="gtag-init" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              ${analytics ? `gtag('config', '${GA4_MEASUREMENT_ID}');` : ""}
              ${marketing ? GOOGLE_ADS_IDS.map((id) => `gtag('config', '${id}');`).join("\n              ") : ""}
            `}
          </Script>
        </>
      )}
    </>
  )
}
